import { UseCase } from '@mdd/api';
import { User } from '../../models';

export class IsCompanyAdminUser implements UseCase<User | undefined, boolean> {
    execute(user: User | undefined): boolean {
        return !!user && user.authorities.includes('ROLE_COMPANY_ADMIN_USER');
    }
}
